/* import __COLOCATED_TEMPLATE__ from './conversation-state-dot-icon.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */

import Component from '@glimmer/component';
import { ConversationState } from 'embercom/objects/inbox/conversation';

interface Signature {
  Args: {
    conversationState: ConversationState;
  };
}

export default class ConversationStateDotIcon extends Component<Signature> {
  get cssClassName(): string {
    return {
      [ConversationState.Open]: 'bg-beta-fill',
      [ConversationState.Snoozed]: 'bg-notice-fill',
      [ConversationState.Closed]: 'bg-neutral-container',
    }[this.args.conversationState];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStateDotIcon': typeof ConversationStateDotIcon;
    'inbox2/conversation-state-dot-icon': typeof ConversationStateDotIcon;
  }
}
